import { SvgIcon, SvgIconProps } from "@mui/material";

const CloseIconGivency = (props: SvgIconProps) => (
  <SvgIcon
    width="40"
    height="40"
    viewBox="0 0 40 40"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    {...props}
  >
    <rect
      x="15.1992"
      y="14.5001"
      width="14.5676"
      height="0.988631"
      transform="rotate(45 15.1992 14.5001)"
      fill="black"
    />
    <rect
      width="14.5676"
      height="0.988631"
      transform="matrix(-0.707107 0.707107 0.707107 0.707107 24.8008 14.5001)"
      fill="black"
    />
  </SvgIcon>
);

export default CloseIconGivency;
